<script setup lang="ts">
import type { HTMLAttributes } from "vue"
import { cn } from "@/lib/utils"

const props = defineProps<{
  class?: HTMLAttributes["class"]
}>()
</script>

<template>
  <Icon name="tabler:loader-2" role="status" aria-label="Loading" :class="cn('size-4 animate-spin', props.class)" />
</template>
